// src/services/ticketFields.js
// Local hardcoded Zoho Help Desk ticket field definitions including cascade dependencies.
// This replaces the API fetch to eliminate CORS/network dependency entirely.

// Field IDs used to navigate the dependency map
const FIELD_IDS = {
  CASE_TYPE_REASON: '805338000030824203',
  CASE_TYPE_SUB_REASON: '805338000030824442',
};

const ZOHO_STATIC_DATA = {
  data: [
    {
      apiName: 'cf_case_type',
      allowedValues: [
        "Complaint",
        "Enquiry",
        "Request",
        "Suggestions/Feedback",
        "Junks",
        "Internal Communications",
        "VAP Campaign",
        "Others"
      ],
      dependency: {
        "Complaint": {
          "805338000030824203": [
            "CMP- AMC Issue",
            "CMP- Application Issue",
            "CMP- Service Centre Issue",
            "CMP- Product Knowledge Issue",
            "CMP- Rude Staff",
            "CMP- Faulty Vehicle",
            "CMP- Car Delivery Issue",
            "CMP- Wrong Transaction",
            "CMP- Repayment not updated",
            "CMP- Car Documents",
            "CMP- Liquidation Issue",
            "CMP- Loan Restructuring Issue",
            "CMP- Dealer Management",
            "CMP- Vehicle Repossession",
            "CMP- Wrong Plate Number",
            "CMP- Loan Repayment Issue",
            "CMP- Plate Number issue",
            "CMP- CAC Document Issue",
            "CMP Bank- Faulty Vehicle",
            "CMP Bank- Document Issue",
            "CMP Bank- Vehicel Maintenance Issue",
            "CMP Bank- PFI Issue",
            "CMP-Account Statement Issue",
            "Final Message for Repossession"
          ]
        },
        "Enquiry": {
          "805338000030824203": [
            "EQ- Application Declined",
            "EQ- Car Delivery",
            "EQ- Car Purchase",
            "EQ- Cash Loan",
            "EQ- Change Mind",
            "EQ- Equity Release",
            "EQ- Financing Repayments",
            "EQ- Payment Confirmation",
            "EQ- Car Sales",
            "EQ- Vehicle Documents",
            "RQ- Service Center",
            "EQ- Insurance",
            "EQ-Car Swap Services",
            "EQ-Car Rental Services"
          ]
        },
        "Request": {
          "805338000030824203": [
            "RQ- AMC",
            "RQ- Car Documents",
            "RQ- Re-Apply",
            "RQ- Repayment Liquidation",
            "RQ- Repayment Reconciliation",
            "RQ- Insurance Claim",
            "RQ- Credit Report",
            "RQ- Statement of account",
            "RQ- Car Repairs",
            "RQ- Loan Cancellation Request",
            "RQ- Service Center",
            "RQ- LONI",
            "RQ- Cash Loan Top-up",
            "RQ-Repayment Date Extension",
            "RQ- Tracker Access",
            "Warranty Claim",
            "RQ - Spare Key",
            "RQ - Reposession Relief Appeal",
            "RQ - Security Deposit",
            "Car Valuation",
            "Office Location"
          ]
        },
        "Suggestions/Feedback": {
          "805338000030824203": [
            "Feedback"
          ]
        },
        "Junks": {
          "805338000030824203": [
            "Junks"
          ]
        },
        "Internal Communications": {
          "805338000030824203": [
            "Internal Communications"
          ]
        },
        "VAP Campaign": {
          "805338000030824203": [
            "VAP- Tyre Purchase",
            "VAP- Document Renewal",
            "Customer Onboarding",
            "Credit Life Insurance"
          ]
        },
        "Others": {
          "805338000030824203": [
            "Legal Case",
            "Sponsorship and Partnership",
            "Job Application",
            "Dropped Calls",
            "Transferred to Collections Team",
            "Voluntary Surrender",
            "Dropped Chat",
            "Survey Calls"
          ]
        }
      }
    },
    {
      apiName: 'cf_case_type_reason',
      dependency: {
        "CMP- Loan Restructuring Issue": { "805338000030824442": ["Loan tenure not accurate"] },
        "RQ- Service Center": { "805338000030824442": ["Change of Service center request"] },
        "EQ- Car Purchase": {
          "805338000030824442": [
            "How to buy a car from Autochek",
            "Application requirements",
            "Can I buy a car from any dealer in Nigeria so that Autochek can Finance the purchase?",
            "Can Autochek finance a car from any dealer?",
            "Can I come with my mechanic/technician to inspect",
            "What are your requirements for vehicle financing?",
            "Can I source for the car by myself from another dealer",
            "Do I get a discount if I buy outrightly",
            "Can I buy a car from anywhere in Nigeria?",
            "Interested in Credcorp",
            "Can I buy a car outrightly from Autochek Website?"
          ]
        },
        "Credit Life Insurance": { "805338000030824442": ["Credit Life Insurance"] },
        "CMP- Loan Repayment Issue": { "805338000030824442": ["Debited twice for a repayment"] },
        "CMP Bank- Faulty Vehicle": { "805338000030824442": ["Faulty Vehicle"] },
        "Warranty Claim": { "805338000030824442": ["Warranty Claim"] },
        "CMP- Repayment not updated": { "805338000030824442": ["Repayment is yet to be updated"] },
        "CMP Bank- Document Issue": { "805338000030824442": ["Car Document Delay", "Car Document Discrepancy"] },
        "CMP- Liquidation Issue": { "805338000030824442": ["Liquidation amount is wrong"] },
        "CMP- Dealer Management": { "805338000030824442": ["Dealer Commissions not paid"] },
        "EQ- Car Sales": { "805338000030824442": ["Sales of vehicles"] },
        "CMP- CAC Document Issue": { "805338000030824442": ["CAC Document Blacklisted"] },
        "RQ - Security Deposit": { "805338000030824442": ["Request for Security deposit"] },
        "RQ- Re-Apply": { "805338000030824442": ["I would like to try the application again"] },
        "CMP- Vehicle Repossession": {
          "805338000030824442": [
            "My vehicle was repossessed and sold",
            "Variance in Repossession Charges"
          ]
        },
        "Legal Case": { "805338000030824442": ["Legal Case"] },
        "CMP Bank- PFI Issue": { "805338000030824442": ["Wrong amount on PFI", "Delay in PFI"] },
        "RQ- Tracker Access": { "805338000030824442": ["Access to Tracker Request"] },
        "Customer Onboarding": { "805338000030824442": ["Customer Onboarding"] },
        "CMP- Application Issue": {
          "805338000030824442": [
            "Why is my application delayed",
            "Credit Bureau not updated"
          ]
        },
        "Job Application": { "805338000030824442": ["Interested in Joining Autochek"] },
        "Voluntary Surrender": { "805338000030824442": ["Voluntary Surrounder"] },
        "EQ- Vehicle Documents": {
          "805338000030824442": [
            "How to get car documents delivered to me?",
            "How do I renew my car documents?"
          ]
        },
        "RQ Bank- PPI": { "805338000030824442": ["Vehicle Inspection Request"] },
        "EQ- Application Declined": { "805338000030824442": ["Why was my application declined/rejected"] },
        "EQ- Cash Loan": {
          "805338000030824442": [
            "Documents needed to apply for a car collateral loan",
            "How much can I borrow against my car",
            "Cash loan enquiry",
            "I already have a GPS tracker installed in my car",
            "Is comprehensive insurance required for a cash loan?",
            "How long does it take to get approved for a cash loan?",
            "What happens if I am unable to repay the loan on time"
          ]
        },
        "EQ- Financing Repayments": { "805338000030824442": ["How do I make repayments?"] },
        "Transferred to Collections Team": { "805338000030824442": ["Transferred to Collections Team"] },
        "Car Valuation": { "805338000030824442": ["Car Valuation Request"] },
        "CMP- Wrong Plate Number": { "805338000030824442": ["Wrong Plate number issued"] },
        "EQ-Car Swap Services": { "805338000030824442": ["Car Swap Inquiry"] },
        "RQ- LONI": { "805338000030824442": ["Request for letter of Non-Indebtedness"] },
        "EQ-Car Rental Services": { "805338000030824442": ["Car Rental Inquiry"] },
        "Sponsorship and Partnership": { "805338000030824442": ["Sponsorship and Partnership"] },
        "CMP- Service Centre Issue": {
          "805338000030824442": [
            "Complaint of Missing Car part after vehicle leaves service center",
            "The problem still exists after the service of the car",
            "Customer pays for the replacement of a car part but part not replaced",
            "Customer claims car was further damaged at the service center",
            "New issue started right after the service",
            "Use of substandard or incorrect parts or products.",
            "Misdiagnosis of the problem",
            "Missed critical inspections"
          ]
        },
        "Junks": { "805338000030824442": ["Junks"] },
        "RQ- AMC": {
          "805338000030824442": [
            "Missed deadlines for repairs or maintenance.",
            "Vehicle Service request"
          ]
        },
        "RQ- Car Repairs": { "805338000030824442": ["Request for car repairs"] },
        "VAP- Document Renewal": {
          "805338000030824442": [
            "Insurance Renewal",
            "RoadWorthiness Renewal",
            "Vehicle License Renewal",
            "Road Worthiness and Vehicle License Renewal",
            "Insurance RW and Vehicle License Renewal"
          ]
        },
        "CMP Bank- Vehicel Maintenance Issue": { "805338000030824442": ["Vehicle Maintenance Issue"] },
        "Dropped Chat": { "805338000030824442": ["Dropped Chat"] },
        "RQ- Statement of account": { "805338000030824442": ["Statement of account - repayment pattern"] },
        "RQ-Repayment Date Extension": { "805338000030824442": ["Repayment Date Extension Request"] },
        "VAP- Tyre Purchase": {
          "805338000030824442": [
            "Tyre Financing",
            "Tyre Top Up"
          ]
        },
        "EQ- Payment Confirmation": { "805338000030824442": ["Confirmation of Loan Repayment"] },
        "CMP- Wrong Transaction": { "805338000030824442": ["Wrongly paid to Autochek"] },
        "EQ- Car Delivery": {
          "805338000030824442": [
            "Deliver to my location",
            "Vehicle Pick Up"
          ]
        },
        "RQ- Repayment Reconciliation": {
          "805338000030824442": [
            "Loan Repayment Reconciliation",
            "Loan Restructuring"
          ]
        },
        "RQ Bank- Car Document": { "805338000030824442": ["Car Document Retrieval"] },
        "Office Location": { "805338000030824442": ["Request for Office Address"] },
        "RQ- Cash Loan Top-up": { "805338000030824442": ["Cash Loan top-up request"] },
        "Feedback": { "805338000030824442": ["Feedback / Suggestions"] },
        "RQ Bank- PFI": { "805338000030824442": ["Request for PFI"] },
        "Dropped Calls": { "805338000030824442": ["Dropped Call"] },
        "RQ- Credit Report": { "805338000030824442": ["Credit Report from Credit Bureau"] },
        "CMP- AMC Issue": {
          "805338000030824442": [
            "Repairs or replacements not covered as promised",
            "Servicing Invoice",
            "Service Sticker",
            "Unused AMC Refund Request"
          ]
        },
        "RQ- Insurance Claim": { "805338000030824442": ["Insurance claims for accidents"] },
        "Internal Communications": { "805338000030824442": ["Internal Communications"] },
        "CMP- Car Delivery Issue": { "805338000030824442": ["Delayed delivery"] },
        "CMP- Rude Staff": { "805338000030824442": ["Unprofessional or rude staff"] },
        "CMP- Plate Number issue": { "805338000030824442": ["My Car Plate Number is Missing"] },
        "CMP- Car Documents": {
          "805338000030824442": [
            "Car documents not ready",
            "Car documents delay",
            "Wrong Plate number issued"
          ]
        },
        "CMP-Account Statement Issue": { "805338000030824442": ["Incomplete statement period"] },
        "RQ - Reposession Relief Appeal": { "805338000030824442": ["Request for Repossession Relief Consideration"] },
        "Final Message for Repossession": { "805338000030824442": ["Final Message for Repossession"] },
        "CMP- Faulty Vehicle": {
          "805338000030824442": [
            "Vehicle has multiple issues",
            "Bad engine",
            "Car not starting",
            "AC not working",
            "Car has rusts"
          ]
        },
        "RQ- Loan Cancellation Request": { "805338000030824442": ["Request for loan cancellation"] },
        "EQ- Insurance": { "805338000030824442": ["How insurance works"] },
        "RQ Bank- Payment Update": { "805338000030824442": ["Request for proof of payment"] },
        "RQ - Spare Key": { "805338000030824442": ["Request for Spare Key"] },
        "RQ- Car Documents": {
          "805338000030824442": [
            "Documents Renewal",
            "Documents Retrieval",
            "Request for Change of Ownership"
          ]
        },
        "Survey Calls": { "805338000030824442": ["Missed Call from Survey"] },
        "EQ- Change Mind": {
          "805338000030824442": [
            "Change mind after initial deposit",
            "Change mind before deposit is made",
            "Change Mind after down payment"
          ]
        },
        "CMP- Product Knowledge Issue": {
          "805338000030824442": [
            "Miscommunication about pricing or services",
            "Unclear explanations about repairs or maintenance",
            "Repairs or replacements not covered as promised"
          ]
        }
      }
    },
    {
      apiName: 'cf_escalation_path',
      allowedValues: ["-None-", "N/A", "Operations", "AFS", "The Customer", "Bank Engagement", "Bank Operations", "Finance", "Telematics", "Customer Success Partner", "Legal", "Repo", "Customer Experience", "Marketing", "HR"]
    },
    {
      apiName: 'cf_type_of_issue',
      allowedValues: ["Vehicle issues/Faulty car", "Tracker issues", "Insurance claim", "Document renewals", "Vehicle Servicing", "Loan Payments", "Loan Liquidation", "General Inquiry", "Promotional Emails", "Internal", "Loan Request", "Apprehension", "Repair finance request", "Robbery", "Expired doc", "AMC", "Accident", "Others"]
    },
    {
      apiName: 'cf_document_type',
      allowedValues: ["-None-", "Registration", "Insurance"]
    },
    {
      apiName: 'cf_country',
      allowedValues: ["Kenya", "Uganda", "Nigeria", "Ghana", "Senegal", "Cote Ivoire"]
    }
  ]
};

/**
 * Fetches raw field definitions from the local static Zoho portal data.
 */
export async function fetchTicketFields() {
  return ZOHO_STATIC_DATA;
}

/**
 * Parses the raw API response into the cascade maps used by the form.
 */
export function parseTicketFields(data) {
  const fields = data?.data ?? [];

  const find = (apiName) => fields.find((f) => f.apiName === apiName);

  const caseTypeField   = find('cf_case_type');
  const caseReasonField = find('cf_case_type_reason');
  const escalationField = find('cf_escalation_path');
  const issueTypeField  = find('cf_type_of_issue');
  const docTypeField    = find('cf_document_type');
  const countryField    = find('cf_country');

  // ── caseType → reasons cascade ──────────────────────────────────────
  const caseReasonsByType = {};
  Object.entries(caseTypeField?.dependency ?? {}).forEach(([caseType, depsObj]) => {
    const reasons = depsObj[FIELD_IDS.CASE_TYPE_REASON] ?? [];
    caseReasonsByType[caseType] = reasons;
  });

  // ── reason → sub-reasons cascade ────────────────────────────────────
  const subReasonsByReason = {};
  Object.entries(caseReasonField?.dependency ?? {}).forEach(([reason, depsObj]) => {
    const subs = depsObj[FIELD_IDS.CASE_TYPE_SUB_REASON] ?? [];
    if (subs.length > 0) {
      subReasonsByReason[reason] = subs;
    }
  });

  return {
    caseTypeOptions:    caseTypeField?.allowedValues   ?? [],
    caseReasonsByType,
    subReasonsByReason,
    escalationOptions:  escalationField?.allowedValues ?? [],
    issueTypeOptions:   issueTypeField?.allowedValues  ?? [],
    documentTypeOptions: docTypeField?.allowedValues   ?? [],
    countryOptions:     countryField?.allowedValues    ?? [],
  };
}
